import Button from '@/Components/Button';
import Input from '@/Components/Input';
import Label from '@/Components/Label';
import { Head, useForm } from '@inertiajs/inertia-react';
import date from '@/helpers/date';
import Authenticated from '@/Layouts/Authenticated';
import ValidationErrors from '@/Components/ValidationErrors';
import Select from 'react-select';

const Create = ({ store, ...props }) => {


    const { data, setData, processing, post } = useForm({
        'name': '',
        'email': '',
        // 'admin_id': null,
        'address': '',
        'telephone': '',
        'schedule_title': '',
        'schedule_description': '',
        'class_limit': 10,
        'birthday_limit': 0,
        'softland_id': null,
        'softland_cost_center': ''
    });

    const onHandleChange = (event) => {
        setData(event.target.name, event.target.type === 'checkbox' ? event.target.checked : event.target.value);
    };

    const submit = (event) => {
        event.preventDefault();

        post(route('branch-office.store'));
    }

    // const handleSelect = ({ value: id }) => {
    //     setData('admin_id', id);
    // };

    return (
        <Authenticated
            branchOffice={props.office}
            store={store}
            auth={props.auth}
            errors={props.errors}
            header={<h2 className="font-semibold text-xl text-gray-800 leading-tight">Crear sucursal</h2>}
        >

            <Head title={`Crear sucursal - ${store === 'cerogrado' ? 'Cerogrado' : 'Trampoline Park'}`} />

            <ValidationErrors errors={props.errors} />
            <form onSubmit={submit} className="p-4 mt-8 max-w-3xl mx-auto">
                <div className="grid grid-cols-1 w-full gap-4 mb-4">
                    <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                        <div>
                            <Label forInput="name" value="Nombre de la sucursal" />
                            <Input
                                name="name"
                                handleChange={onHandleChange}
                                value={data.name}
                                type="text"
                                className="w-full"
                            />
                        </div>
                        <div>
                            <Label forInput="email" value="Correo electronico de la sucursal" />
                            <Input
                                name="email"
                                handleChange={onHandleChange}
                                value={data.email}
                                type="text"
                                className="w-full"
                            />
                        </div>
                        <div>
                            <Label forInput="softland_id" value="Softland bodega" />
                            <Input
                                name="softland_id"
                                handleChange={onHandleChange}
                                value={data.softland_id}
                                type="text"
                                className="w-full"
                            />
                        </div>
                    </div>
                    <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                        <div>
                            <Label forInput="address" value="Direccion de la sucursal" />
                            <Input
                                name="address"
                                handleChange={onHandleChange}
                                value={data.address}
                                type="text"
                                className="w-full"
                            />
                        </div>
                        <div>
                            <Label forInput="telephone" value="Telefono de la sucursal" />
                            <Input
                                name="telephone"
                                handleChange={onHandleChange}
                                value={data.telephone}
                                type="text"
                                className="w-full"
                            />
                        </div>
                        <div>
                            <Label forInput="softland_cost_center" value="Softland Centro de costos" />
                            <Input
                                name="softland_cost_center"
                                handleChange={onHandleChange}
                                value={data.softland_cost_center}
                                type="text"
                                className="w-full"
                            />
                        </div>
                    </div>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                        <div>
                            <Label forInput="schedule_title" value="Titulo horario pista" />
                            <Input
                                name="schedule_title"
                                handleChange={onHandleChange}
                                value={data.schedule_title}
                                type="text"
                                className="w-full"
                            />
                        </div>
                        <div>
                            <Label forInput="schedule_description" value="Descripcion horario pista" />
                            <Input
                                name="schedule_description"
                                handleChange={onHandleChange}
                                value={data.schedule_description}
                                type="text"
                                className="w-full"
                            />
                        </div>
                    </div>
                    <div className="grid grid-cols-1 md:grid-cols-12 gap-4">
                        {/* <div>
                            <Label forInput="admin_id" value="Administrador" />
                            <Select
                                id="admin_id"
                                styles={{
                                    indicatorSeparator: () => ({ display: "none" }),
                                    input: (styles) => ({
                                        ...styles,
                                        "> input": {
                                            boxShadow: "none !important",
                                        },
                                    }),
                                }}
                                className="rounded-md shadow-none"
                                options={props.admins.map(admin => {
                                    return {
                                        value: admin.id,
                                        label: admin.name
                                    }
                                })}
                                value={
                                    data.admin_id && Boolean(props.admins.length)
                                        ? {
                                            value: data.admin_id,
                                            label: props.admins.find(({ id }) => id === data.admin_id).name,
                                        }
                                        : {
                                            value: null,
                                            label: "Seleccione un administrador",
                                        }
                                }
                                noOptionsMessage={() =>
                                    "No hay administradores en el sistema"
                                }
                                onChange={(value) => handleSelect(value)}
                            />
                        </div> */}

                        <div className="col-span-3">
                            <Label forInput="class_limit" value="Límite de tickets de clase por día" />
                            <Input
                                name="class_limit"
                                handleChange={onHandleChange}
                                value={data.class_limit}
                                type="text"
                                className="w-full"
                            />
                        </div>
                        <div className="col-span-2">
                            <Label forInput="quota" value="Aforo general" />
                            <Input
                                name="quota"
                                handleChange={onHandleChange}
                                value={data.quota}
                                type="text"
                                className="w-full"
                            />
                        </div>
                        <div className="col-span-2">
                            <Label forInput="birthday_limit" value="Aforo cumpleaños" />
                            <Input
                                name="birthday_limit"
                                handleChange={onHandleChange}
                                value={data.birthday_limit}
                                type="text"
                                className="w-full"
                            />
                        </div>
                    </div>
                </div>
                <Button processing={processing}>Guardar</Button>
            </form>
        </Authenticated>
    )
}

export default Create;
